import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";

export function useGroupForm() {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const setName = useCallback(
    (name) => {
      reset({ name });
    },
    [reset],
  );

  const resetForm = useCallback(() => {
    reset({ name: "" });
  }, [reset]);

  const getName = useCallback(() => {
    return getValues("name");
  }, [getValues]);

  return {
    control,
    errors,
    handleSubmit,
    getName,
    setName,
    resetForm,
  };
}
